export enum FulfilmentActivityType {
    Link = "LINK",
    Create = "CREATE",
    Complete = "COMPLETE",
    Close = "CLOSE",
    Reopen = "REOPEN",
}
